import { DisplayElementModel } from '../../PageBuilder/models/display-element.model';
import { ChartColorPickerFieldModel } from '../../PageBuilder/models/chart-color-picker-field.model';
import { RadioButtonOptionModel } from './radio-button-option.model';

export class ChartColorRadioOptionModel extends RadioButtonOptionModel  {
    colorOptions: ChartColorPickerFieldModel[];

    constructor(
        label: string,
        key: string,
        disabled: boolean = false,
        tooltip: string = '',
        subRadioOptions?: RadioButtonOptionModel[],
        enableCondition?: (displayElement: DisplayElementModel) => boolean,
        displayRadioButton: boolean = true,
        colorOptions?: ChartColorPickerFieldModel[],
    ) {
        super(label, key, disabled, tooltip, subRadioOptions, enableCondition, displayRadioButton);
        this.colorOptions = colorOptions;
    }
}
